import { render, staticRenderFns } from "./TableStatistics.vue?vue&type=template&id=298a53f9&scoped=true"
import script from "./TableStatistics.js?vue&type=script&lang=js&external"
export * from "./TableStatistics.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298a53f9",
  null
  
)

export default component.exports